import { TextView } from '@ui/components/TextView';

import { LoginForm, LoginFormData } from '@features/auth/ui/LoginForm';
import { SimpleSubHeader } from '@features/shared/ui/SimpleSubHeader';

import styles from './LoginPage.module.css';

const PHONE = undefined;
const EMAIL = 'info@chessopen.ru';

type Props = {
  isPending?: boolean;
  isError?: boolean;
  onSubmit?: (data: LoginFormData) => void;
  onChessOpenClick?: () => void;
};

export function LoginPage({ isPending, isError, onSubmit, onChessOpenClick }: Props) {
  return (
    <>
      <SimpleSubHeader title="Турнирная платформа ChessOpen" />

      <div className={styles.content}>
        <div className={styles.description}>
          <TextView className={styles.description}>
            Наша платформа позволяет создавать шахматные клубы и проводить как открытые турниры, так
            и состязания по приглашению. Удобные настройки и приятный игровой интерфейс позволят
            провести онлайн-турнир на самом высоком уровне.
            <br />
            <br />
            Если вы хотите организовать турнир, свяжитесь с нашим менеджером, который проведет
            демонстрацию платформы и поможет зарегистрировать шахматный клуб.
          </TextView>
          <div className={styles.contacts}>
            {PHONE && (
              <a href={`tel:${PHONE}`} className={styles.phone}>
                {PHONE}
              </a>
            )}
            {EMAIL && <a href={`mailto:${EMAIL}`}>{EMAIL}</a>}
          </div>
        </div>
        <LoginForm
          loading={isPending}
          onSubmit={onSubmit}
          onChessOpenClick={onChessOpenClick}
          loginError={isError}
        />
      </div>
    </>
  );
}
